import { Injectable, NgZone } from '@angular/core';
import { ActionType } from '@models/widget/action-type.enum';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class NavigationService {
  private urlHistory: string[] = [];
  private actionHistory: ActionType[] = [];

  private maxHistory = 20;
  private history: string[] = [];
  private allowedBackTargets = [
    /^\/home?$/, /^\/profile$/,   /^\/faq\/billing?$/,
     /^\/billing\/autopay$/,  /^\/billing-new(\/.*)?$/,
    /^\/my-insurance?$/, /^\/my-insurance\/\d+\/details?$/, 
    /^\/my-insurance\/\d+\/billing?$/, /^\/contact?$/
  ];

  constructor(
    private router: Router,
    private ngZone: NgZone
  ) {
    this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)).subscribe(
        (event: NavigationEnd) => {
          const url = event.urlAfterRedirects;
          if (!this.isAllowed(url) || (this.history.length > 0 && this.history[this.history.length - 1] === url)) {
            return;
          }
          this.history.push(url); 
          if (this.history.length > this.maxHistory) { 
            this.history.shift(); 
          }
        });
  }

  viewHistory() {
    return this.urlHistory
  }

  viewActionHistory() {
    console.log("Last customer Activity :: ", this.actionHistory)
  }

  getActionHistory(): ActionType[] {
    return this.actionHistory;
  }

  saveCurrentUrl() {
    this.urlHistory.unshift(this.router.url);
    if (this.urlHistory.length > 10) {
      this.urlHistory.shift();
    }
  }

  saveCurrentAction(currAction: ActionType) {
    this.actionHistory = this.actionHistory.filter(act => act !== currAction)
    this.actionHistory.unshift(currAction);

    if (this.actionHistory.length > 4) {
      this.actionHistory.shift();
    }
  }

  goBackToRecentUrl(partialUrls: string[]){
    for(let i = this.history.length - 1; i >= 0; i--){
      const url = this.history[i];
      const match = partialUrls.some(part => url.includes(part));
      if(match){
        this.router.navigateByUrl(url, { replaceUrl: true });  
        return;
      }     
    }
    this.router.navigate([`/home`]);
   }



  navigateToRecentUrl(partialUrl1: string, partialUrl2: string) {
    const lastUrl1Indx = this.urlHistory.indexOf(this.urlHistory.find(url => url.includes(partialUrl1)));
    const lastUrl2Indx = this.urlHistory.indexOf(this.urlHistory.find(url => url.includes(partialUrl2)));

    if(lastUrl2Indx === -1 && lastUrl1Indx === -1)
      this.router.navigate([`/home`]);
    else if(lastUrl2Indx === -1)
      this.router.navigateByUrl(this.urlHistory[lastUrl1Indx], { replaceUrl: true });
    else if(lastUrl1Indx === -1)
      this.router.navigateByUrl(this.urlHistory[lastUrl2Indx], { replaceUrl: true });
    else
      this.router.navigateByUrl((lastUrl1Indx < lastUrl2Indx) 
        ? this.urlHistory[lastUrl1Indx] : this.urlHistory[lastUrl2Indx]);
   }

  navigateBack() { 
    const currentUrl = this.router.url;
    if (this.history.length > 0 && this.history[this.history.length - 1] === currentUrl) {
      this.history.pop();
    }

    const target = this.history.pop();
    
      
    if (target) { 
      this.router.navigateByUrl(target, { replaceUrl: true }); 
    } else { 
      this.router.navigate([`/home`]);
    } 
  }

  private isAllowed(url: string): boolean {
    return this.allowedBackTargets.some(pattern => pattern.test(url));
  }
}
